import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
//Components
import DataTable from "react-data-table-component";
import Layout from "../../../../Layout/Layout";
import Constants from "../../../../common/SupplierConstants";
import { SearchField } from "../../../../Components/formElements/SearchField";
import { useDispatch, useSelector } from "react-redux";
import {
  addEstimation,
  addQuotationh,
  getEstimationList,
  // getQtnJobList,
} from "../../../../redux/feature/customer_app/customerV1Slice";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import { formatDate } from "../../../../common/Validations";
import StickyColumn from "../../../../Components/Sticky/StickyColumn";
import CustomerConstants from "../../../../common/CustomerConstants";
import { useNavigate } from "react-router-dom";
import MultiColumnFilter from "../../../../Components/MultiColumnFilter/MultiColumnFilter";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
// import CommonFilterCustomerV2 from "../Common/CommonFilterCustomerV2";
import "./FrontWallTable.scss";
import EstimationDetailsModal from "./EstimationDetailsModal"; // adjust path
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import DeleteEstimation from "./DeleteEstimation";
import EstimationDeactivateModel from "./EstimationDeactiivateModel";
import ShowStatus from "../../../../Components/Modal/supplier_app/Workflow/ShowStatus";

//
import ItemServiceV1 from "../../../../services/customer_appCommonService";
import toast from "react-hot-toast";
import ItemService from "../../../../services/customer_appCommonService";
import EstimationFilterModal from "./EstimationFilterModal";

const EstimationList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  localStorage.setItem("menu", "");
  localStorage.setItem("submenu", "");

  //  let reportInfo = useSelector((state) => state?.report); // Report Details from Store
  let config = useSelector((state) => state?.common?.data?.suppliers); // User Details from Store
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const [filterShow, setFilterShow] = useState(false);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const [modalDeleteEstimation, setModalDeleteEstimation] = useState(false);
  const [getEntryListData, setEntryListData] = useState();
  const [selectedRows, setSelectedRows] = useState([]);
  // const [gelectedRowsEstimationandVerison, selectedRowsEstimationandVerison] = useState([]);
  const [getShowSupplierDeactivateModel, setShowSupplierDeactivateModel] =
    useState(false);

  const [modalShowStatus, setModalShowStatus] = useState(false);
  const [sendDataModal, setSendDataModal] = useState("");
  const [modelTitle, setModelTitle] = useState("");
  const [lastFilterBuilding, setLastFilterBuilding] = useState(null); // NEW

  // let qtnData = useSelector((state) => state?.customerV1?.quotation_Job); // User Details from Store
  // let quotationTable = useSelector(
  //   (state) => state?.customerV1?.quotation_Job?.pagination
  // );
  let userData = useSelector((state) => state?.user?.data); // User Details from Store

  const [userRole, setUserRole] = useState("");

  useEffect(() => {
    setUserRole(userData?.roles?.[0]?.roleId || "");
  }, [userData]);

  let estData = useSelector((state) => state?.customerV1?.estimation); // User Details from Store
  let estimationTable = useSelector(
    (state) => state?.customerV1?.estimation?.pagination
  );

  const [data, setData] = useState();
  // eslint-disable-next-line
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  const [isCardVisible1, setCardVisible1] = useState(true);
  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  // const loadQuotationData = async () => {
  //   setData(estData?.data);
  // };
  const loadQuotationData = async () => {
    let rows = estData?.data || [];
    if (lastFilterBuilding) {
      rows = rankEstimationsByCloseness(rows, lastFilterBuilding);
    }
    setData(rows);
  };

  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const handleViewDetails = (row) => {
    setSelectedRow(row);
    setShowDetailsModal(true);
  };

  const handleHideDetails = () => {
    setShowDetailsModal(false);
    setSelectedRow(null);
  };
  // eslint-disable-next-line
  const createEstimate = (qtnNo) => {
    dispatch(addQuotationh(qtnNo));
    navigate(CustomerConstants.CUSTOMER_V4_CUSTOMER_ESTIMATE_E1);
  };
  const estimationDisplay = (documentNumber) => {
    dispatch(addEstimation(documentNumber));
    navigate(
      CustomerConstants.CUSTOMER_V4_CUSTOMER_ESTIMATE_SPECIFICATION_DETAILS
    );
  };
  const estimateRevision = (documentNumber) => {
    dispatch(addEstimation(documentNumber));
    navigate(
      CustomerConstants.CUSTOMER_V4_CUSTOMER_ESTIMATE_SPECIFICATION_DETAILS_REVISION
    );
  };
  const handleDownloadExcel = async () => {
    let obj = {
      queryName: "Get_ESTIMATION_LIST",
      page: 1,
      per_page: 100,
    };
    // console.log("obj", obj);
    await ItemServiceV1.downloadExcel(obj).then((item) => {
      const url = window.URL.createObjectURL(new Blob([item]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Export_${"Get_ESTIMATION_LIST"}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    });
  };

  const handlePageChange = (page) => {
    let obj = {
      queryName: "Get_ESTIMATION_LIST",
      module: "CUSTOMER",
      page: page,
      per_page: getNewPerPage,
    };
    dispatch(getEstimationList(obj));
    setData(estData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "Get_ESTIMATION_LIST",
      module: "CUSTOMER",
      page: page,
      per_page: newPerPage,
    };
    setNewPerPage(newPerPage);
    dispatch(getEstimationList(obj));
    setData(estData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "Get_ESTIMATION_LIST",
      module: "",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getEstimationList(obj));
  };

  useEffect(() => {
    loadQuotationData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [estData]);
  // for filter
  useEffect(() => {
    if (!estData?.data) return;

    let rows = estData.data;

    if (lastFilterBuilding?.useGeometry) {
      rows = rankEstimationsByCloseness(rows, lastFilterBuilding);
    }

    setData(rows);
  }, [estData, lastFilterBuilding]);

  //on page load
  useEffect(() => {
    let obj = {
      queryName: "Get_ESTIMATION_LIST",
      module: "",
      page: 1,
      per_page: 10,
    };
    dispatch(getEstimationList(obj));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line
  const [formInputs, setFormInputs] = useState({});
  // eslint-disable-next-line
  const [disabled, setDisabled] = useState();

  const handleCancel = async () => {
    console.log(">>selectedRows123", selectedRows);
    const documentNumber = selectedRows[0];
    // console.log(">>documentNumber",documentNumber)
    try {
      setDisabled(true);

      const obj = {
        documentNumber: documentNumber,
        headerStatus: "Estimation Cancelled",
      };

      const item = await ItemService.updateEstimation(obj);
      if (item?.status === 200) {
        toast.success(item?.message || "Estimation Cancelled Successfully", {
          duration: 2000,
          position: "top-right",
        });
        const obj = {
          queryName: "Get_ESTIMATION_LIST",
          page: 1,
          per_page: 10,
          searchTerm: "",
          // rowFilter: filters.length > 0 ? { $and: filters } : {},
        };

        dispatch(getEstimationList(obj));
      } else {
        toast.error(item?.message || "Failed to cancel, please try again!", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (error) {
      console.error("Cancel failed:", error);
      toast.error("Something went wrong, please try again later!", {
        duration: 4000,
        position: "top-right",
      });
    }

    setDisabled(false);
  };

  const quotationList = [
    {
      name: "Estimation Nr",
      id: "documentNumber",
      selector: (row) => row?.documentNumber,
      cell: (row) => (
        <>
          {row?.headerStatus === "Estimation Draft" ? (
            <button
              className="btnInfo "
              onClick={() => estimationDisplay(row?.estimationNr)}
            >
              {/* <span className="d-block text-nowrap">Modify</span> */}
              {/* <span className="text-nowrap">{row?.documentNumber}</span> */}
              {row.jobReferenceNr ? (
                <span>
                  {row.jobReferenceNr} {"(J)"}
                </span>
              ) : row.qtnReferenceNr ? (
                <span>
                  {row.qtnReferenceNr} {"(Q)"}
                </span>
              ) : (
                "-"
              )}
            </button>
          ) : (
            <button
              className="btnInfo"
              onClick={() => estimationDisplay(row?.estimationNr)}
            >
              {/* {row?.documentNumber} */}
              {row.jobReferenceNr ? (
                <span>
                  {row.jobReferenceNr} {"(J)"}
                </span>
              ) : row.qtnReferenceNr ? (
                <span>
                  {row.qtnReferenceNr} {"(Q)"}
                </span>
              ) : (
                "-"
              )}
            </button>
          )}
        </>
      ),
      width: "120px",
    },

    {
      name: "Version",
      id: "version",
      selector: (row) => row?.version,
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-success-status">
            {row.version}
          </span>
        </>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Jon/Qtn Ref",
      id: "version",
      selector: (row) => row?.jobReferenceNr || row?.qtnReferenceNr,
      cell: (row) => (
        <>
          {row.jobReferenceNr ? (
            <span className="bg-table-status bg-table-success-status">
              {row.jobReferenceNr} {"(J)"}
            </span>
          ) : row.qtnReferenceNr ? (
            <span className="bg-table-status bg-table-warning-status">
              {row.qtnReferenceNr} {"(Q)"}
            </span>
          ) : (
            "-"
          )}
        </>
      ),
      sortable: true,
      width: "150px",
    },

    {
      name: "Revision",
      selector: (row) => row.documentNumber || "--",
      cell: (row) => {
        const isDisabled = row.draftStatus === "DF";
        return (
          <button
            title="Revision"
            className={`btnInfo w-75 ${isDisabled ? "btn-dim w-75 " : ""}`}
            onClick={() => estimateRevision(row.documentNumber, row.revision)}
            disabled={isDisabled}
          >
            <i className="bi bi-repeat pe-2"></i>
            {/* <span className="m-0 p-0 pt-1">Revision</span> */}
          </button>
        );
      },
      sortable: true,
      width: "120px",
    },
    {
      name: "Status",
      selector: (row) => row.headerStatus,
      cell: (row) => <TableStatusField status={row.headerStatus} />,
      width: "200px",
    },
   {
  name: "Workflow log",
  selector: (row) => row.workflowActionLogs,
  cell: (row) => {
    const isDisabled =
      row?.headerStatus === "Estimation Draft" ||
      row?.version?.toLowerCase() === "v0";

    return (
      <div
        style={{ width: "100%", opacity: isDisabled ? 0.4 : 1 }}
        className="d-flex justify-content-center iconTable"
      >
        <img
          src="assets/img/newIcons/workflow.png"
          alt="attachments"
          style={{
            width: "35px",
            cursor: isDisabled ? "not-allowed" : "pointer",
          }}
          className="mt-1"
          onClick={() => {
            if (!isDisabled) {
              showStatusInfo(row.workflowActionLogs);
            }
          }}
        />
      </div>
    );
  },
  sortable: true,
  width: "132px",
},

    {
      name: "Client/Company",
      selector: (row) => row.companyName,
      id: "companyName",
      dropDown: true,
      cell: (row) => (
        <div>
          <p className="">{row.companyName}</p>
          <p className="fw-bold">{row.clientName}</p>
        </div>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Tonnage/Area",
      selector: (row) => row.grandTotalWeight,
      id: "grandTotalWeight",
      dropDown: true,
      cell: (row) => (
        <div>
          <p className="fw-bold text-primary">
            {(row?.grandTotalWeight
              ? row.grandTotalWeight.toFixed(3)
              : "0.000") + " KG"}
          </p>
          <p className="fw-medium text-success">
            {row?.getOverallBuildingArea?.toFixed(3) + " SqFt"}
          </p>
          <p className="fw-medium text-primary">
            {row?.buildingTypes}
          </p>
        </div>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Cost",
      selector: (row) => row.grandTotalPrice,
      id: "grandTotalPrice",
      dropDown: true,
      cell: (row) => (
        <div>
          <p className="fw-bold text-success">
            {row?.grandTotalPrice?.toFixed(3)} <span className="fw-bold text-primary">INR{" "}</span>
          </p>
        </div>
      ),
      sortable: true,
      width: "160px",
    },

    {
      name: "Allocate",
      selector: (row) => row.assignTo,
      cell: (row) => {
        // If no assignTo → hide button completely
        if (!row.assignTo || row.assignTo.length === 0) {
          return <span style={{ color: "gray", fontSize: "13px" }}>--</span>;
        }

        const colors = ["green", "red", "blue", "cyan", "orange", "gray"];

        const renderFlow = (
          <div style={{ padding: "8px 0" }}>
            <div style={{ marginBottom: "10px", fontSize: "14px" }}>
              <div>
                <strong>Assigned By:</strong> { row.assignByName || "--"}
              </div>

              <div>
                <strong>Created By:</strong> {row.createdBy}
              </div>

              <div>
                <strong>Created Name:</strong> {row.createdName || "--"}
              </div>
            </div>

            <hr style={{ margin: "8px 0" }} />

            {row.assignTo?.map((item, index) => (
              <div
                key={index}
                className="d-flex align-items-start"
                style={{ marginBottom: "10px" }}
              >
                {/* Time Label */}
                <div style={{ width: "55px", fontSize: "13px" }}>
                  {index === 0 ? "0 " : index === 1 ? "1 " : `${index} `}
                </div>

                {/* Dot + Line */}
                <div
                  style={{
                    position: "relative",
                    marginRight: "10px",
                    marginLeft: "5px",
                  }}
                >
                  <span
                    style={{
                      width: "10px",
                      height: "10px",
                      backgroundColor: colors[index] || "gray",
                      display: "inline-block",
                      borderRadius: "50%",
                      marginTop: "4px",
                    }}
                  ></span>

                  {index !== row.assignTo.length - 1 && (
                    <div
                      style={{
                        width: "2px",
                        height: "28px",
                        background: "#d0d4fc",
                        position: "absolute",
                        left: "4px",
                        top: "14px",
                      }}
                    ></div>
                  )}
                </div>

                {/* Flow Details */}
                <div style={{ fontSize: "14px" }}>
                  <strong>{item.checkerName}</strong> – {item.checkerId}
                </div>
              </div>
            ))}
          </div>
        );

        return (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="flow-tooltip">{renderFlow}</Tooltip>}
          >
            <button className="bi bi-person-fill fs-5 text-primary"></button>
          </OverlayTrigger>
        );
      },
      width: "120px",
    },

    {
      name: "Created By",
      selector: (row) => row.createdBy,
      cell: (row) => (
        <>
          <div>
            <p className="fw-bold">{row.createdBy}</p>
            <p className="d-block">{row.createdName}</p>
            {/* <p className="d-block">{row.createdAt}</p> */}
            <p className="d-block fw-bold">
  {new Date(row.createdAt).toLocaleDateString('en-IN', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  })}
</p>
          </div>
        </>
      ),
      sortable: true,
      width: "180px",
    },

    {
      name: "Details",
      cell: (row) => (
        <div className="d-flex align-items-center gap-2">
          <OverlayTrigger
            placement="top"
            delay={{ show: 150, hide: 200 }}
            overlay={
              <Tooltip
                id={`tooltip-${row.documentNumber}`}
                className="custom-tooltip"
              >
                <div style={{ textAlign: "left" }}>
                  <strong>Estimation Nr:</strong> {row.documentNumber} <br />
                  <strong>Est Created Date:</strong>{" "}
                  {formatDate(row.estimationDate)} <br />
                  <strong>Est Start Date:</strong>{" "}
                  {formatDate(row.estimateStartdate)} <br />
                  <strong>Est End Date:</strong>{" "}
                  {formatDate(row.estimateEndDate)} <br />
                  <strong>Sales Officer:</strong>{" "}
                  {row?.salesOfficerName || "--"} <br />
                  <strong>Building Structure:</strong>{" "}
                  {row?.buildingTypes || "--"} <br />
                  <strong>Remark:</strong> {row?.qtn_Job_Remarks || "--"}
                  <br />
                  <strong>Quotation Nr:</strong> {row?.quotationNr || "--"}
                  <br />
                  <strong>Quotation Nr:</strong> {row?.quotationNr || "--"}
                  <br />
                  <strong>Created Name:</strong> {row?.createdName || "--"}
                  <br />
                  {row?.transactionNr &&
                    !row.transactionNr.startsWith("QU") && (
                      <>
                        <strong>Job Nr:</strong> {row.transactionNr} <br />
                      </>
                    )}
                </div>
              </Tooltip>
            }
          >
            <button
              className="btn btn-light p-1 border-0"
              title="View Details"
              onClick={() => handleViewDetails(row)}
            >
              <i className="bi bi-eye fs-5 text-primary"></i>
            </button>
          </OverlayTrigger>
        </div>
      ),
      width: "120px",
    },
    {
      name: "Delete",
      selector: (row) => row.purchaseType || "--",
      cell: (row) => (
        <div>
          <button onClick={() => deleteEstimation(row)}>
            <i className="bi bi-trash text-danger fs-4" />
          </button>
        </div>
      ),
      omit: userRole !== "DESIGN-MANAGER",

      sortable: true,
      width: "100px",
    },
  ];

  const handleFilterData = async (filters) => {
    const obj = {
      queryName: "Get_ESTIMATION_LIST",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: filters.length > 0 ? { $and: filters } : {},
    };

    dispatch(getEstimationList(obj));
  };

  const columnsForFilter = quotationList
    .filter((col) => col.id || col.selectorKey)
    .map((col) => ({
      name: col.name,
      selectorKey: col.id || col.selectorKey,
      dropDown: col.dropDown || false,
      range: col.range || false,
      month: col.month || false,
    }));
  //delet
  const deleteEstimation = (data) => {
    setModalDeleteEstimation(true);
    setEntryListData(data);
  };

  const hideModal = () => {
    setModalDeleteEstimation(false);
  };

  // assign
  const hideSupplierDeactivateModel = () =>
    setShowSupplierDeactivateModel(false);
  // const handleRowSelect = (selectedRows ) => {

  //   // setSelectedRows(selectedRows);
  // };
  //   const handleRowSelect = (state) => {
  //   const rows = state?.selectedRows || [];
  //   const ids = rows.map(item => item.documentNumber); // now map works
  //   setSelectedRows(ids);
  // };
  const handleRowSelect = (state) => {
    const rows = state?.selectedRows || [];

    const uniqueIds = [...new Set(rows.map((item) => item.documentNumber))];

    setSelectedRows(uniqueIds);
  };

  const handleDeactivateSupplier = async (payload) => {
    try {
      // setIsPageLoading(true); // Start loading
      const supplierIds = selectedRows.map((row) => row.userId);
      let obj = {
        supplierIds: supplierIds,
        remark: payload?.remark,
      };
      console.log("obj", obj);
      // await ItemService.supplierDeactivate(obj).then((item) => {
      //   // console.log(">> item!", item);
      //   if (item?.status === 200) {
      //     // successModalData.successMsg = item?.message;
      //     // setsucceModalData(successModalData);
      //     // onSuccessmodel();
      //   } else {
      //   }
      // });
    } catch (error) {
      console.log("Failed to De-activate:", error);
    } finally {
      // setIsPageLoading(false); // End loading
    }
  };
  //workflow status
  const showStatusInfo = (rowData) => {
    setModalShowStatus(true);
    setSendDataModal(rowData);
    setModelTitle("Status Information");
  };

  const hideModalStatus = () => {
    setModalShowStatus(false);
  };
  // for filtration
  const [showEstimationFilterModal, setShowEstimationFilterModal] =
    useState(false);

  const handleShowEstimationFilter = () => {
    setShowEstimationFilterModal(true);
  };
  const handleHideEstimationFilter = function () {
    setShowEstimationFilterModal(false);
  };
  // for filter query name
  // ---------- FRONTEND RANKING ----------
  const rankEstimationsByCloseness = (rows, filterBuilding) => {
    if (!filterBuilding?.useGeometry) return rows;

    const sides = ["front", "back", "left", "right"];

    return (rows || [])
      .map((row) => {
        const buildings = row.buildings || [];
        let bestScore = Infinity;

        buildings.forEach((b) => {
          let score = 0;

          // wall lengths
          sides.forEach((side) => {
            const target = parseFloat(filterBuilding[side]?.meters);
            const actual = parseFloat(b[side]?.meters);
            if (!isNaN(target) && !isNaN(actual)) {
              score += Math.abs(actual - target);
            }
          });

          // eave heights (if present)
          const targetLeft = parseFloat(filterBuilding.lswEaveHeight);
          const actualLeft = parseFloat(b.eaveHeightLSW);
          if (!isNaN(targetLeft) && !isNaN(actualLeft))
            score += Math.abs(actualLeft - targetLeft);

          const targetRight = parseFloat(filterBuilding.rswEaveHeight);
          const actualRight = parseFloat(b.eaveHeightRSW);
          if (!isNaN(targetRight) && !isNaN(actualRight))
            score += Math.abs(actualRight - targetRight);

          if (score < bestScore) bestScore = score;
        });

        return { ...row, matchScore: bestScore };
      })
      .sort((a, b) => (a.matchScore || Infinity) - (b.matchScore || Infinity));
  };

  const applyBuildingFilterFrontend = ({
    building,
    useStructure,
    useDesign,
    useGeometry,
  }) => {
    const filters = [];

    if (useStructure) {
      if (building.mainBuildingTypeCode)
        filters.push({
          "buildings.mainBuildingTypeCode": building.mainBuildingTypeCode,
        });
      if (building.buildingTypesCode)
        filters.push({
          "buildings.buildingTypesCode": building.buildingTypesCode,
        });
      if (building.buildingStructureCode)
        filters.push({
          "buildings.buildingStructureCode": building.buildingStructureCode,
        });
      if (building.designCode)
        filters.push({ "buildings.designCode": building.designCode });
    }

    if (useDesign) {
      if (building.designLoad.deadLoad)
        filters.push({
          "buildings.designLoad.deadLoad": building.designLoad.deadLoad,
        });
      if (building.designLoad.liveLoad)
        filters.push({
          "buildings.designLoad.liveLoad": building.designLoad.liveLoad,
        });
      if (building.designLoad.solarLoad)
        filters.push({
          "buildings.designLoad.solarLoad": building.designLoad.solarLoad,
        });
      if (building.designLoad.windLoad)
        filters.push({
          "buildings.designLoad.windLoad": building.designLoad.windLoad,
        });

      if (building.designStandards.codesApplicable)
        filters.push({
          "buildings.designStandards.codesApplicable":
            building.designStandards.codesApplicable,
        });
      if (building.designStandards.windLoadCalculation)
        filters.push({
          "buildings.designStandards.windLoadCalculation":
            building.designStandards.windLoadCalculation,
        });
      if (building.designStandards.windLoadApplication)
        filters.push({
          "buildings.designStandards.windLoadApplication":
            building.designStandards.windLoadApplication,
        });
      if (building.designStandards.seismicLoad)
        filters.push({
          "buildings.designStandards.seismicLoad":
            building.designStandards.seismicLoad,
        });
    }

    if (useGeometry) {
      // example: ±10% tolerance around target length
      const addLengthRangeFilter = (fieldPath, targetMeters) => {
        const value = parseFloat(targetMeters);
        if (isNaN(value)) return;

        const tolerance = value * 0.1; // 10% either side
        filters.push({
          [fieldPath]: {
            $gte: Number(value - tolerance),
            $lte: Number(value + tolerance),
          },
        });
      };

      // front/back/left/right
      addLengthRangeFilter("buildings.front.meters", building.front?.meters);
      addLengthRangeFilter("buildings.back.meters", building.back?.meters);
      addLengthRangeFilter("buildings.left.meters", building.left?.meters);
      addLengthRangeFilter("buildings.right.meters", building.right?.meters);

      // eave heights if backend has eaveHeightLSW / eaveHeightRSW at building level
      const addHeightRangeFilter = (fieldPath, target) => {
        const v = parseFloat(target);
        if (isNaN(v)) return;
        const tol = v * 0.1;
        filters.push({
          [fieldPath]: {
            $gte: String(v - tol),
            $lte: String(v + tol),
          },
        });
      };

      addHeightRangeFilter(
        "buildings.selectedCaseObject.eaveHeightLSW",
        building.lswEaveHeight
      );
      addHeightRangeFilter(
        "buildings.selectedCaseObject.eaveHeightRSW",
        building.rswEaveHeight
      );
    }

    const rowFilter = filters.length ? { $and: filters } : {};
    console.log("rowFilter", rowFilter);

    const obj = {
      queryName: "Get_ESTIMATION_LIST",
      module: "",
      page: 1,
      per_page: 50,
      searchTerm: "",
      rowFilter,
    };

    setLastFilterBuilding({
      ...building,
      useGeometry,
      useDesign,
      useStructure,
    });
    dispatch(getEstimationList(obj));
  };

  // called by modal
  const handleEstimationFilterData = ({
    building,
    useStructure,
    useDesign,
    useGeometry,
  }) => {
    applyBuildingFilterFrontend({
      building,
      useStructure,
      useDesign,
      useGeometry,
    });
  };

  // reset to default list (10 per page, no filter)
  const handleClearEstimationFilter = () => {
    setLastFilterBuilding(null);
    const obj = {
      queryName: "Get_ESTIMATION_LIST",
      module: "",
      page: 1,
      per_page: 10,
      searchTerm: "",
    };
    dispatch(getEstimationList(obj));
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">Estimation List</h2>
                <p className="subText">Estimation List Details</p>
              </Col>
              <Col
                xs={12}
                md={3}
                lg={3}
                className="d-flex justify-content-end mt-3"
              >
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={12} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i class="bi bi-filter"></i>
                </span>
              </Col>
            </Row>
            <hr />
            {filterShow && (
              <MultiColumnFilter
                columns={columnsForFilter}
                data={data}
                onFilter={handleFilterData}
                onCancel={() => setFilterShow(false)}
              />
            )}

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">EL</span>
                    </Col>
                    <Col xs={4} md={9} lg={6}>
                      <span className="headerTitle">Estimation List</span>
                    </Col>
                    {userRole === "DESIGN-MANAGER" &&
                      config?.deactivateListBtn && (
                        <Col
                          xs={4}
                          md={2}
                          lg={2}
                          className="d-flex justify-content-end "
                        >
                          <button
                            className="btnTable"
                            onClick={() => setShowSupplierDeactivateModel(true)}
                          >
                            <i class="bi bi-people px-2"></i>
                            Assign
                          </button>
                        </Col>
                      )}

                    <Col
                      xs={3}
                      md={1}
                      lg={1}
                      className="d-flex justify-content-end"
                    >
                      <button
                        className="btnTable btnTableCancel ms-2"
                        onClick={() => handleCancel(formInputs?.documentNumber)}
                      >
                        <i className="bi bi-x-circle me-1"></i> Cancel
                      </button>
                    </Col>
                    <Col xs={3} md={1} lg={1} className="flex justify-end">
                      <button
                        className="btnTable ms-2"
                        onClick={handleShowEstimationFilter}
                      >
                        <i className="bi bi-filter me-1"></i> Filter
                      </button>
                    </Col>
                    <Col xs={2} md={1} lg={1} className="">
                      <div className="filter">
                        <span
                          className="icon hide headerIcon"
                          data-bs-toggle="dropdown"
                          aria-expanded="true"
                        >
                          <i className="bi bi-three-dots"></i>
                        </span>
                        <ul
                          className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                          data-popper-placement="bottom-end"
                        >
                          <li className="dropdown-header text-start">
                            <h6>Menu</h6>
                          </li>
                          <li>
                            <span
                              className="dropdown-item headerIcon"
                              onClick={handleDownloadExcel}
                            >
                              <i className="bi bi-download mr-2"></i>
                              Download Excel
                            </span>
                          </li>
                          {/* <li>
                                <span
                                  className="dropdown-item headerIcon"
                                  onClick={handleDownloadPDF}
                                >
                                  <i className="bi bi-download mr-2"></i>
                                  Download PDF
                                </span>
                              </li> */}
                        </ul>
                      </div>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <StickyColumn
                          columnIndexes={[1, 2, 3, 4]}
                          leftOffsets={[0, 40, 150, 260]}
                        />
                        <DataTable
                          title=""
                          columns={quotationList}
                          data={data}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          onChangeRowsPerPage={handlePerRowsChange}
                          paginationTotalRows={estimationTable.total}
                          onChangePage={handlePageChange}
                          onSelectedRowsChange={handleRowSelect}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
      <EstimationDetailsModal
        show={showDetailsModal}
        onHide={handleHideDetails}
        rowData={selectedRow}
      />
      <DeleteEstimation
        show={modalDeleteEstimation}
        onHide={() => hideModal()}
        data={getEntryListData}
        // dropdownData={getAccountGroup}
      />
      <EstimationDeactivateModel
        show={getShowSupplierDeactivateModel}
        onHide={hideSupplierDeactivateModel}
        onSubmit={handleDeactivateSupplier}
        selectedRows={selectedRows}
      />
      <ShowStatus
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />
      <EstimationFilterModal
        show={showEstimationFilterModal}
        onHide={handleHideEstimationFilter}
        onApplyFilter={handleEstimationFilterData}
        onClearFilter={handleClearEstimationFilter}
      />
    </main>
  );
};

export default EstimationList;
